<template>
  <TsSection v-if="orderStore.is_order_loading">
   <div  >
    <TsLoadingCircularSpinner/>
  </div> 
  </TsSection>
  <div v-else>

    <div v-if="orderStore.is_order_error" class="flex justify-center">
  <TsSection class="w-full">
    <TsColumn appendClass="md:is-8 is-12 text-center mx-auto">
      <TsTypography align="center" append-class="text-danger" as="h1">
      {{useTranslation("orderIdNotFound" , "Bestellings-ID niet gevonden")}}
      </TsTypography>
      <TsTypography align="center" append-class="text-black mb-5">
        <strong>"071-5815050"</strong>
        {{ useTranslation("OrderConfirmation-emailMessage", "of door een e-mail te sturen naar") }}
        <strong>info@toolstation.nl</strong>.
      </TsTypography>
      <TsRow no-gutter class="gap-2 justify-center m-0">
        <NuxtLinkLocale to="/">
          <TsButton
            data-testid="continueShopping"
            :label="continueShopping"
            append-class="whitespace-nowrap"
          />
        </NuxtLinkLocale>
  
      </TsRow>
    </TsColumn>
  </TsSection>
</div>


  <div v-if="orderStore.order_id && !orderStore.is_order_error">
    <TsSection >
      <TsRow appendClass=" " :isMultiline="isMobile">
        <TsColumn appendClass="md:is-8 is-12 text-center">
          <TsImage
            src="/images/thank-you-green.gif"
            width="110"
            alt="thank-you"
            height="110"
            class="mx-auto"
            loading="lazy"
          />
          <TsTypography align="center" append-class="text-success" as="h1" data-testid="order-confirmation-message"
            >{{ useTranslation("OrderConfirmation-orderPlacedMessage", "Uw bestelling is geplaatst")
            }},<br />
            {{ useTranslation("thankYou", "Bedankt") }} <br />
            {{ useTranslation("orderId", "Bestel-ID") }} -
            {{ orderStore.order_id }}
          </TsTypography>
          <TsTypography align="center" append-class="text-black mb-5">
            {{
              useTranslation(
                "OrderConfirmation-orderConfirmationMessage",
                "Er is een e-mail verzonden om uw bestelling te bevestigen. Als u een suggestie heeft over de bestelling, neem dan contact op met de klantenservice. U kunt ons bereiken op "
              ) 
            }}
            <strong> 071-5815050 </strong
            >{{ useTranslation("OrderConfirmation-emailMessage", "of door een e-mail te sturen naar") }}
            <strong>info@toolstation.nl</strong
            >.
          </TsTypography>
          <TsRow no-gutter class="gap-2 justify-center m-0">
            <NuxtLinkLocale to="/">
              <TsButton
                data-testid="continueShopping"
                :label="continueShopping"
                append-class="whitespace-nowrap"
              />
            </NuxtLinkLocale>

            <NuxtLinkLocale :to="!authStore.user ? '/register' : '/account/home'">
              <TsButton outlined data-testid="my-account" :label="!authStore.user ? createAccount : myAccount" />
            </NuxtLinkLocale>
          </TsRow>
        </TsColumn>
        <TsColumn appendClass="md:is-4 is-12 max-md:mt-4">
          <TsCard noShadow appendClass="py-4 px-3">
            <div v-if="authStore.guest">
              <TsRow append-class="m-0 mb-2">
                <TsIcon size="24" name="gg:profile" color="#065CAB"/>
                <TsTypography append-class="text-primary text-lg font-semibold m-0 ml-2">{{ useTranslation("guestInformation", "Gastinformatie")}}</TsTypography>
              </TsRow>
              <TsRow class="justify-between m-0" v-for="(value, label) in guestInfo" :key="label">
                <TsTypography append-class="text-idle-black mb-0">{{ label }}:</TsTypography>
                <TsTypography append-class="text-idle-black mb-0" weight="bold">{{ value }}</TsTypography>
              </TsRow>
              <TsDivider append-class="mb-6 mt-0"/>
            </div>
            
            <TsAccordion append-class="rounded-lg overflow-hidden">
              <TsAccordionTab
                append-class="first:border-t-0 border-0 bg-white "
                body-class="border-b-0 bg-white"
                :data-testid="`${orderStore.order_id}-order-summary`"
              >
                <template #heading>
                  <TsRow class="items-center m-0">
                    <TsIcon name="mdi:cart-outline" size="24" class="text-primary mr-3" />
                    <TsTypography append-class="mb-0 text-lg p-0 text-primary font-semibold">{{
                      useTranslation("orderSummary", "Order Summary")
                    }}</TsTypography>
                  </TsRow>
                </template>
                <div class="max-h-80 overflow-y-scroll pt-2 scroll-container bg-white">
                  <div
                    v-if="orderStore.products"
                    class="relative overflow-visible rounded-xl pt-4 pb-2 px-4 mb-4 last:mb-0 bg-white"
                  >
                    <TsMedia
                      v-for="product in orderStore.products"
                      appendClass="items-center border-t"
                    >
                      <TsMediaStart appendClass=" p-2 mr-0">
                        <TsImage
                          v-if="product.product && product.product.image"
                          height="60"
                          width="49"
                          :src="product.product.image"
                          :alt="product.product.code"
                          loading="lazy"
                        />
                      </TsMediaStart>
                      <TsMediaContent appendClass="p-2">
                        <TsTypography variant="h5" append-class="mb-0">
                          <span class="text-idle-black">{{ product.product.name }} </span>
                        </TsTypography>
                      </TsMediaContent>
                      <TsMediaEnd>
                        <TsTypography append-class="text-idle-black">{{
                          product.prices.product_formatted
                        }}</TsTypography>
                      </TsMediaEnd>
                    </TsMedia>
                  </div>
                </div>
              </TsAccordionTab>
            </TsAccordion>
            <TsRow class="justify-between pb-1.5 m-0" no-gutter> </TsRow>
            <TsRow class="justify-between pt-3 border-t items-center m-0">
              <TsTypography append-class="mb-0 text-idle-black"
                >{{ useTranslation("orderTotal", "Bestel totaal") }} <br />
                <TsTypography size="xs" as="span">{{
                  useTranslation("includingTaxes", "Inclusief belastingen")
                }}</TsTypography>
              </TsTypography>
              <TsTypography
                append-class="mb-0 text-idle-black"
                weight="bold"
                as="span "
                >{{ orderStore.order_total }}</TsTypography
              >
            </TsRow>
          </TsCard>
        </TsColumn>
      </TsRow>
    </TsSection>

    <TsSection appendClass="mb-4">
      <TsAccordion
        :data-testid="`${orderStore.order_id}-collection-address`"
        v-if="orderStore.is_collection"
        appendClass=" border-l border-r border-b bg-white overflow-hidden rounded-xl"
      >
        <TsAccordionTab
          appendClass="px-4 py-4 border-0 flex-row-reverse"
          body-class="pb-4 px-4 border-0"
          :heading= "useTranslation('viewCollectionAddressDetails', 'Bekijk de afhaaladresgegevens')"
        >
          <TsDivider appendClass="mt-0 mb-2" />
          <TsGrid
            :cols="2"
            :isMultiline="isMobile"
            appendClass="rounded-xl max-md:flex-row-reverse"
          >
            <TsColumn appendClass="is-12">
              <div class="flex items-end justify-between">
                <div>
                  <TsTypography weight="semibold" appendClass="mb-3 text-idle-black"
                    >{{useTranslation('collectionAddress', 'Ophaaladres:')}}</TsTypography
                  >
                  <TsTypography
                    append-class="mb-0"
                    v-html="orderStore.collection_address?.details"
                  ></TsTypography>
                </div>
                <div>
                  <TsButton
                    v-if="orderStore.collection_address"
                    append-class="whitespace-nowrap"
                    size="sm"
                    :block="isMobile"
                    :label= "useTranslation('getDirection' , 'Krijg richting')"
                    @click="branchStore.onShowRoute(orderStore.collection_address)"
                  />
                </div>
              </div>
            </TsColumn>

            <TsColumn class="is-12 row-span-2 max-md:mb-2">
            <TsAllStoresMap
                v-if="orderStore.is_collection && orderStore.collection_address"
                dataTestid="order-confirmation-map-for-click-and-collect-branch-address"
                append-class="rounded-xl overflow-hidden h-60 md:h-full"
                :stores="[orderStore.collection_address]"
              />
            </TsColumn>
            <TsColumn>
            </TsColumn>
          </TsGrid>
        </TsAccordionTab>
      </TsAccordion>
      <TsAccordion
        :data-testid="`${orderStore.order_id}-collection-address`"
        v-if="orderStore.is_next_day_collection"
        appendClass=" border-l border-r border-b bg-white overflow-hidden rounded-xl"
      >
        <TsAccordionTab
          appendClass="px-4 py-4 border-0 flex-row-reverse"
          body-class="pb-4 px-4 border-0"
          :heading= "useTranslation('viewNextDayCollection', 'Bekijk de adresgegevens van de volgende dag ophaalservice')"
        >
          <TsDivider appendClass="mt-0 mb-2" />
          <TsGrid
            :cols="2"
            :isMultiline="isMobile"
            appendClass="rounded-xl max-md:flex-row-reverse"
          >
            <TsColumn appendClass="is-12">
              <div class="flex items-end justify-between">
                <div>
                  <TsTypography weight="semibold" appendClass="mb-3 text-idle-black"
                    >{{useTranslation("nextDayCollection" , "Collectie op de volgende dag:")}}</TsTypography
                  >
                  <TsTypography
                    append-class="mb-0"
                    v-html="orderStore.collection_address?.details"
                  >
                  </TsTypography>
                </div>
                <div>
                  <TsButton
                    v-if="orderStore.collection_address"
                    append-class="whitespace-nowrap"
                    size="sm"
                    :block="isMobile"
                    :label= "useTranslation('getDirection' , 'Krijg richting')"
                    @click="branchStore.onShowRoute(orderStore.collection_address)"
                  />
                </div>
              </div>
            </TsColumn>

            <template v-if="orderStore.collection_address">
              <TsColumn class="is-12 row-span-2 max-md:mb-2">
                <TsAllStoresMap
                  dataTestid="order-confirmation-map-for-click-and-collect-branch-address"
                  append-class="rounded-xl overflow-hidden h-60 md:h-full"
                  :stores="[orderStore.collection_address]"
                />  
              </TsColumn>
              <TsColumn>
                <TsOpeningHoursTable dataTestid="next-day-collection-opening-hours" :time-slots="orderStore.collection_address.opening_hours" />
              </TsColumn>
            </template>
          </TsGrid>
        </TsAccordionTab>
      </TsAccordion>

      <TsAccordion
        :data-testid="`${orderStore.order_id}-delivery-address`"
        v-if="orderStore.is_delivery"
        appendClass="border-l border-r border-b bg-white overflow-hidden rounded-xl"
      >
        <TsAccordionTab
          appendClass="px-4 py-4 border-0 flex-row-reverse"
          body-class="pb-6 px-4 border-0"
          :heading="deliveryDetails"
        >
          <TsDivider appendClass="mt-0 mb-4 " />
          <TsRow isMultiline no-gutter appendClass="items-center">
            <TsColumn appendClass="lg:is-6 is-12 lg:border-r lg:mb-0 mb-5 lg:!pr-6">
              <TsMedia appendClass=" items-end">
                <TsMediaStart appendClass="">
                  <TsTypography weight="semibold" appendClass="mb-3 text-idle-black">{{
                    useTranslation("deliveryAddress", "Afleveradres")
                  }}:</TsTypography>
                  <div v-if="orderStore.delivery_address &&  orderStore.delivery_address.formatted"
                    v-html="
                      generateFormattedDeliveryAddress(
                        orderStore.delivery_address.formatted
                      )
                    "
                  ></div>
                </TsMediaStart>
                <TsMediaEnd>
                  <TsButton :size="!isMobile ? 'md' : 'sm'" :label='useTranslation("trackOrder" , "Volg bestelling")' @click="handleTrackHistory(orderStore.order_id)" />
                </TsMediaEnd>
              </TsMedia>
            </TsColumn>
            <TsColumn appendClass="lg:is-6 is-12 lg:!pl-6">
              <TsAlert
                dataTestid="guarantee_alert"
                variant="info"
                has-icon
                appendClass="border-l-[6px]  border-info p-2 bg-[#145FE11A]"
              >
                <template #alert-msg>
                  <TsTypography as="p" variant="h2" appendClass="text-info mb-0">
                    {{ useTranslation("note", "Note") }}:
                  </TsTypography>
                </template>
                <template #alert-content>
                  <TsTypography appendClass="text-idle-black ml-0">
                    {{
                      useTranslation(
                        "delayedDeliveryMessage",
                        "Tijdens piekperioden zoals Black Friday, Pasen en Kerstmis kan de bezorging vertraging oplopen."
                      )
                    }}
                  </TsTypography>
                </template>
              </TsAlert>
            </TsColumn>
          </TsRow>
        </TsAccordionTab>
      </TsAccordion>
      <TsAccordion
        appendClass=" border-b border-l border-r bg-white overflow-hidden rounded-xl"
      >
        <TsAccordionTab
          v-if="orderStore.is_directship"
          body-class=" pb-6 px-4 border-0"
          appendClass="px-4 py-4 border-0 flex-row-reverse"
          :heading= "useTranslation('viewSupplierOrderDetails' , 'Bekijk de bestelgegevens van leveranciers')"
        >
          <TsDivider appendClass="mt-0 mb-4" />
          <TsRow isMultiline no-gutter>
            <TsColumn v-if="orderStore.delivery_address" appendClass="lg:border-r lg:mb-0 mb-5 lg:is-6 is-12 lg:!pr-6">
              <TsMedia appendClass=" items-end">
                <TsMediaStart appendClass="">
                  <TsTypography weight="semibold" appendClass="mb-3 text-idle-black">{{
                    useTranslation("deliveryAddress", "Afleveradres")
                  }}:</TsTypography>
                  <div
                    v-html="
                      generateFormattedDeliveryAddress(
                        orderStore.delivery_address.formatted
                      )
                    "
                  ></div>
                </TsMediaStart>
                <TsMediaEnd>
                  <TsButton :block="isMobile" :label='useTranslation("trackOrder" , "Volg bestelling")' @click="handleTrackHistory(orderStore.order_id)" />
                </TsMediaEnd>
              </TsMedia>
            </TsColumn>
          </TsRow>
        </TsAccordionTab>
      </TsAccordion>
    </TsSection>
  </div>
   

    <TsSection v-if="monetateStore.order_confirmation_recommendations.ids" >
      <TsTypography as="h2" variant="h1" append-class="mb-2 md:text-center">
            {{ useTranslation("productRecommendations", "Product Recommendations") }}
          </TsTypography>

      <TsCarouselCardProduct data-testid="order-confirmation-often-products-carousel" productContextType="recommended" @product-click="monetateStore.trackRecommendationClick(monetateStore.order_confirmation_recommendations, $event)" :productIds="monetateStore.order_confirmation_recommendations.ids" :navigation="!isMobile" />
    </TsSection>
  </div>
</template>

<script setup lang="ts">
import { EventConstants } from "~/assets/constants/ecomApi";
import { useTranslation } from "~/composables/useTranslation";

const TsCard = defineAsyncComponent(() => import('~/components/organisms/TsCard.vue'));
const TsGrid = defineAsyncComponent(() => import('~/components/organisms/TsGrid.vue'));
const TsAccordion = defineAsyncComponent(() => import('~/components/atoms/TsAccordion.vue'));
const TsAccordionTab = defineAsyncComponent(() => import('~/components/atoms/TsAccordionTab.vue'));
const TsMediaStart = defineAsyncComponent(() => import('~/components/organisms/TsMediaStart.vue'));
const TsMediaContent = defineAsyncComponent(() => import('~/components/organisms/TsMediaContent.vue'));
const TsMediaEnd = defineAsyncComponent(() => import('~/components/organisms/TsMediaEnd.vue'));
const TsAllStoresMap = defineAsyncComponent(() => import('~/components/organisms/TsAllStoresMap.vue'));
const TsOpeningHoursTable = defineAsyncComponent(() => import('~/components/organisms/TsOpeningHoursTable.vue'));
const TsCarouselCardProduct = defineAsyncComponent(() => import('~/components/organisms/TsCarouselCardProduct.vue'));

const TsLoadingCircularSpinner = defineAsyncComponent(() => import('~/components/organisms/TsLoadingCircularSpinner.vue'))

const authStore = useAuthStore();

useHead({
  title: `Toolstation | ${useTranslation('orderConfirmation' , 'Orderbevestiging')}`,
  meta: [
    {
      name: "description",
      content: "The page is appear when the client is purchase something.",
    },
  ],
});

onMounted(async () => {
  if(import.meta.client){
  window.monetateQ = window.monetateQ || [];
  window.monetateQ.push(["setPageType", 'purchase']);
  window.monetateQ.push([
    "trackData"
  ]);
  }
  const route = useRoute("checkout-order-confirmation-slug___nl-NL___default");
  if (!orderStore.order_id) {
    await orderStore.getOrderDetails(route.params.slug);
  }

  // Generate a unique key based on the order ID to track if the event has been logged
  const purchaseEventStorageKey = `purchase_logged_${orderStore.order?.data?.id}`;
  const isPurchaseEventLogged = localStorage?.getItem(purchaseEventStorageKey);

  if (isPurchaseEventLogged === 'true') {
    await firePurchaseEvent();
    localStorage?.setItem(purchaseEventStorageKey,'false');
  }
  // Algolia Event
  trackAlgoliaPurchaseEvent();
});

definePageMeta({
  layout: "order-confirmation",
});

const { isMobile } = useDevice();


const accountStore = useAccountStore();
const branchStore = useBranchStore();
const orderStore = useMyOrderStore();
const monetateStore = useMonetateStore();

function generateFormattedDeliveryAddress(address?: Array<any>) {
  return address?.slice(0, address.length).join("<br>");
}

const continueShopping = useTranslation("continueShopping", "Continue Shopping");
const myAccount = useTranslation("myAccount", "My Account");
const deliveryDetails = useTranslation("deliveryDetails", "View delivery order details");
const createAccount = useTranslation("createAccount", "Account aanmaken");

async function handleTrackHistory(orderId: string) {
  await accountStore.handleTrackOrderHistory(orderId);
}

const guestInfo = computed(() => {
  const name = useTranslation("name", "Naam");
  const email = useTranslation("email", "E-mail");
  const mobile = useTranslation("mobile", "Mobile");

  return {
    [name]: `${authStore.guest.first_name} ${authStore.guest.last_name}`,
    [email]: authStore.guest.email,
    [mobile]: authStore.guest.mobile,
  };
});

const firePurchaseEvent = async () => {
  const user = authStore.user;
  const { useRootStore } = await import("~/stores/root.store");
  const { useNuxtApp } = await import("#app");
  const rootStore = useRootStore();
  const nuxtApp = useNuxtApp();
  const userData = {
    customer: user
      ? {
          user_id: user.id,
          email: user.email,
          phone: user.mobile,
          account_type: user.account_type,
          order_count: user.order_count || 0,
          order_value: user.order_value || 0,
        }
      : "User Is Not Logged In",
    page: {
      page_url: window.location.href,
      page_path: window.location.pathname,
      page_referrer: document.referrer,
      page_title: document.title,
      content_group: "",
      content_group2: "",
    },
    site: {
      shop_language: nuxtApp.$i18n.locale.value,
      shop_currency: EventConstants.currency,
      tax_toggle: rootStore.isIncVat ? "Incl." : "Excl.",
      selected_branch: user?.default_branch || null,
    },
  };
  logPurchaseEvent(orderStore.order, userData); // Call GTM event to fire purchase tags
};

async function trackAlgoliaPurchaseEvent() {
  const queryID = sessionStorage.getItem("queryID") ?? "";
  const searchedProductIDs = JSON.parse(
    sessionStorage.getItem("searchedProductIDs") ?? "[]"
  );
  const objectIDs = orderStore.order?.data?.items.map(
    (item) => item.product.code
  );
  const isFromSearch = objectIDs?.some((id) =>
    searchedProductIDs.includes(id)
  );
  const orderTotal = orderStore.order?.data.order_totals.raw;
  if(!objectIDs?.length || !orderTotal) return;
  if (queryID && isFromSearch) {
    const { useAlgoliaEvent } = await import('~/composables/useAlgoliaEvent');
    const algoliaEventHandler = useAlgoliaEvent();
    algoliaEventHandler.sendPurchaseEvent({queryID, objectIDs, orderTotal}); 
  }
  // TODO: else, send generic purchase event
}
</script>
